import { Injectable } from '@angular/core';
import {BackendFunctions, Sherpa} from "../../classes/Sherpa";
import {auth, sherpa, util} from "../../../services";
import {SherpaError} from "../../classes/SherpaError";
import {
	Project,
	Status
} from "../../types/sherpa";

@Injectable({
	providedIn: 'root'
})
export class AdminService {

	private api: BackendFunctions = {};

	constructor() {
		sherpa.api$.subscribe((sherpa: Sherpa) => {
			this.api = sherpa.api;
		});
	}

	updateProject(project: Project) : Promise<Project> {
		return this.api.updateProject<any>(auth.token(), project)
			.catch((e: SherpaError) => util.handleError(e));
	}

	getProjects(): Promise<Project[]> {
		return this.api.getProjects<Project[]>(auth.token())
			.catch((e: SherpaError) => util.handleError(e));
	}

	createProject(project: Project)  : Promise<Project> {
		return this.api.createProject<Project>(auth.token(), project)
			.catch((e: SherpaError) => util.handleError(e));
	}

	deleteProject(project: Project) {
		return this.api.deleteProject<any>(auth.token(), project.id)
			.catch((e: SherpaError) => util.handleError(e));
	}

	getProject(project_id: number) : Promise<Project> {
		return this.api.getProject<Project>(auth.token(), project_id)
			.catch((e: SherpaError) => util.handleError(e));
	}


	getStatus() : Promise<Status> {
		return this.api.getStatus<Status>(auth.token())
			.catch((e: SherpaError) => util.handleError(e));
	}


	getQuayLoadingStatus() : Promise<Boolean> {
		return this.api.getQuayLoadingStatus<Boolean>(auth.token())
			.catch((e: SherpaError) => util.handleError(e));
	}

	loadAndRefeshQuaysInBackground(project_id : number) : Promise<any> {
		return this.api.loadAndRefeshQuaysInBackground<any>(auth.token(), project_id, true)
			.catch((e: SherpaError) => util.handleError(e));
	}
}
